import type * as React from "react";

import { cn } from "@/lib/utils";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn("tw-animate-pulse tw-rounded-md tw-bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };
